import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { customFieldsService } from '../api/custom-fields.service';
import { CUSTOM_FIELD_KEYS } from './queryKeys';
import type { UpsertFieldValueInput } from '../schemas';

export function useUpsertTaskFieldValue(taskId: string) {
  const queryClient = useQueryClient();
  const activeOrganizationId = useOrganizationStore((s) => s.activeOrganizationId);

  return useMutation({
    mutationFn: ({ fieldId, payload }: { fieldId: string; payload: UpsertFieldValueInput }) =>
      customFieldsService.upsertTaskFieldValue(taskId, fieldId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: CUSTOM_FIELD_KEYS.taskValues(activeOrganizationId ?? '', taskId),
      });
    },
  });
}
